<template>
  <button
    class="cursor-pointer whitespace-nowrap transition duration-200 outline-none shrink-0 border inline-flex items-center justify-center disabled:pointer-events-none disabled:opacity-50"
    :class="{
      'w-full': props.block,
      'text-base px-3 py-2 rounded-lg font-bold': props.size === 'large',
      'text-xs px-3 py-2 rounded-lg font-medium': props.size === 'small',
      'text-sm py-2 px-3 rounded-lg font-semibold': props.size === 'default',
      'text-white border-transparent bg-[#030213] hover:bg-gray-800':
        props.variant === 'black',
      'text-[#1E3456] border-transparent bg-white hover:bg-gray-50':
        props.variant === 'white',
      'text-white border-transparent bg-green-600 hover:bg-green-700':
        props.variant === 'green',
      'text-white border-transparent bg-emerald-600 hover:bg-emerald-700':
        props.variant === 'emerald',
      'text-white border-transparent bg-purple-600 hover:bg-purple-700':
        props.variant === 'purple',
      'text-white border-transparent bg-blue hover:bg-[#3B7FDD]':
        props.variant === 'blue',
      'text-white border-transparent bg-[#4289FF] hover:bg-[#3578E6]':
        props.variant === 'primary',
      'text-white border-transparent bg-indigo-600 hover:bg-indigo-700':
        props.variant === 'indigo',
      'text-white border-transparent bg-red-600 hover:bg-red-700':
        props.variant === 'danger',
      'text-white border-transparent bg-amber-600 hover:bg-amber-700':
        props.variant === 'warning',
      'border-2 border-amber-300 text-amber-700 hover:bg-amber-50 hover:border-amber-400':
        props.variant === 'warning-outline',
      '!shadow-none border-transparent text-red-600 hover:text-red-600 hover:bg-red-50':
        props.variant === 'ghost-danger',
      'bg-white border border-red-200 text-red-700 hover:bg-red-50':
        props.variant === 'danger-outline',
      'border-transparent text-foreground bg-white hover:bg-[#e9ebef]':
        props.variant === 'ghost-default',
      'border-[#e5e5e5] text-foreground bg-white hover:bg-[#E0EDFF]':
        props.variant === 'default',
      'border-[#e5e5e5] border text-foreground bg-white hover:bg-[#E0EDFF]/50':
        props.variant === 'default-outline',
      'border-[#4A8EEE]/15 bg-[#E0EDFF]/50 border text-blue hover:bg-[#E0EDFF]':
        props.variant === 'blue-outline',
      'text-white border-transparent bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700':
        props.variant === 'emerald-gradient' /* unique use */,
      'bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700':
        props.variant === 'emerald' && props.useGradient,
      'bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800':
        props.variant === 'indigo' && props.useGradient,
      'bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700':
        props.variant === 'green' && props.useGradient,
      'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700':
        props.variant === 'purple' && props.useGradient,
      'bg-gradient-to-r from-blue to-[#3B7FDD] hover:from-[#3B7FDD] hover:to-[#2E6FCC]':
        props.variant === 'blue' && props.useGradient,
      'shadow-md hover:shadow-lg': !!props.showShadow,
      'pointer-events-none': !!props.loading,
    }"
    :disabled="props.disabled"
  >
    <Loader2Icon
      v-if="props.loading"
      class="w-5 h-5 mr-1 shrink-0 animate-spin opacity-90"
    />
    <slot />
  </button>
</template>

<script setup lang="ts">
import { Loader2Icon } from 'lucide-vue-next';

const props = withDefaults(
  defineProps<{
    variant?:
      | 'indigo'
      | 'emerald'
      | 'purple'
      | 'blue'
      | 'default'
      | 'danger'
      | 'ghost-danger'
      | 'green'
      | 'ghost-default'
      | 'emerald-gradient'
      | 'warning'
      | 'warning-outline'
      | 'danger-outline'
      | 'default-outline'
      | 'blue-outline'
      | 'black'
      | 'primary'
      | 'white';
    showShadow?: boolean;
    useGradient?: boolean;
    loading?: boolean;
    disabled?: boolean;
    size?: 'large' | 'small' | 'default';
    block?: boolean;
  }>(),
  {
    variant: 'default',
    showShadow: false,
    useGradient: false,
    loading: false,
    size: 'default',
    block: false,
  }
);
</script>
